// Shared with the Labs directory so each small service feels like Lawlow.
export const labsPalette = {
  background: "#fff",
  text: "#191d1b",
  muted: "#616963",
  border: "#e2e8e3",
  accent: "#087641",
  selected: "#e7fbef",
  action: "#18271f",
  arrow: "#9af2be",
  preview: "linear-gradient(115deg, #effcf5, #f0f5ff)",
};
